import React from 'react';
import InputNumberField
    from '@src/components/_views/configurable/import-view/file-list/additional-row/fields/InputNumberField';

export default function AdditionalColumnsNumber() {
    return <InputNumberField
            name="additionalColumnsNumber"
            label="List:ImportRecords.item-config.fields.additional-columns"
    />;
}
